import dataStore from '../../data/data';
import Loader from './load/loader';

const Generate = async () => {
  const data=dataStore.getState();
  const setData=dataStore.setState;
  let date = data.mirror.currentDate;

  if (!date) {
    const now = new Date();
    date = `${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')}-${String(now.getFullYear()).slice(-2)}`;

    setData((_data) => ({
      ..._data,
      mirror: {
        ..._data.mirror,
        currentDate: date,
      },
    }));
  }
  
  await Loader();

};

export default Generate;